export const LOCAL = 'local';
export const STAGE = 'stage';
export const PRODUCTION = 'production';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/constants/environments.ts